import { render, staticRenderFns } from "./funBtn.vue?vue&type=template&id=aa589a22"
import script from "./funBtn.vue?vue&type=script&lang=js"
export * from "./funBtn.vue?vue&type=script&lang=js"
import style0 from "./funBtn.vue?vue&type=style&index=0&id=aa589a22&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa589a22')) {
      api.createRecord('aa589a22', component.options)
    } else {
      api.reload('aa589a22', component.options)
    }
    module.hot.accept("./funBtn.vue?vue&type=template&id=aa589a22", function () {
      api.rerender('aa589a22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/funBtn/funBtn.vue"
export default component.exports